<script lang="ts">
  import HomeView from "./lib/views/HomeView.svelte";
  import PhotoFlow from "./lib/views/PhotoFlow.svelte";
  import ScanFlow from "./lib/views/ScanFlow.svelte";
  import PreviewView from "./lib/views/PreviewView.svelte";
  import { createCaptureSession } from "./lib/state/captureSession";
  import { PdfBuilder } from "./lib/pdf/builder";
  import { PhotoWriter } from "./lib/photo/writer";

  const session = createCaptureSession({
    builder: new PdfBuilder(),
    writer: new PhotoWriter()
  });
  const phase = session.phase;
  const output = session.output;
  const pageCount = session.pageCount;

  let modal = $state<"none" | "scan" | "photo">("none");
  let homeError = $state<string | null>(null);

  function onScan() {
    homeError = null;
    modal = "scan";
  }
  function onPhoto() {
    homeError = null;
    modal = "photo";
  }
  function closeModal() {
    modal = "none";
  }
  function onDone() {
    session.reset();
    homeError = null;
  }

  $effect(() => {
    if ($phase.kind === "error") homeError = $phase.message;
  });
</script>

{#if $phase.kind === "ready" && $output}
  <PreviewView {session} output={$output} pageCount={$pageCount} {onDone} />
{:else if $phase.kind === "processing"}
  <div class="flex h-dvh items-center justify-center" role="status" aria-live="polite">
    <p class="text-muted-foreground">
      Processing {$phase.pageCount} page{$phase.pageCount === 1 ? "" : "s"}…
    </p>
  </div>
{:else}
  <HomeView inlineError={homeError} {onScan} {onPhoto} />
{/if}

{#if modal === "photo"}
  <PhotoFlow {session} onClose={closeModal} />
{:else if modal === "scan"}
  <ScanFlow {session} onClose={closeModal} />
{/if}
